import type { CSSProperties } from "react";

/** iOS HIG minimum tap target, in points. */
export const HIT_MIN = 44;

/**
 * How far a control `visual` points tall has to grow, per side, to reach
 * `HIT_MIN`. Zero for a control that is already big enough.
 */
export function hitInset(visual: number): number {
  return Math.max(0, (HIT_MIN - visual) / 2);
}

/**
 * Padding plus an equal negative margin: the tap area grows to 44pt while
 * nothing painted and no neighbour moves (the idiom `SWITCH_HIT` in the You
 * settings already uses). `x` is the horizontal growth per side — pass at
 * most half the gap to the next control so two zones never overlap.
 */
export function hitArea(visualHeight: number, x = 0): CSSProperties {
  const y = hitInset(visualHeight);
  return {
    padding: `${y}px ${x}px`,
    margin: `${y ? -y : 0}px ${x ? -x : 0}px`,
  };
}
